export default "__VITE_ASSET__BBo8WViD__"